import { createStore, combineReducers, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunkMiddleware from 'redux-thunk';

import authReducer from '../Auth/authReducer';
import dataReducer from '../reducers/dataReducer';
import controlsReducer from '../reducers/controlsReducer';
import userReducer from '../reducers/userReducer';
import ganymedeReducer from '../AppModules/Ganymede/ganymedeReducer';
import europaReducer from '../AppModules/Europa/EuropaReducer';

const reducers = combineReducers({
  authReducer,
  controlsReducer,
  dataReducer,
  userReducer,
  ganymedeReducer,
  europaReducer,
});

export default createStore(reducers, composeWithDevTools(applyMiddleware(thunkMiddleware)));
